import { useSelector } from 'react-redux';
import { selectSlackIntegrationStatus } from '../../../reducers/integrationsReducer';
import { getIsAutomationsFormValid } from './automationFormValidationHelper';
import { useAutomationsContext } from '../AutomationsContext';
import { useFormulaEditorState } from '../FormulaEditorStateContext';
import { useValueFromAnotherObjectEditorState } from '../ValueFromAnotherObjectEditorStateContext';

export const useIsAutomationFormValid = () => {
  const dataByVariant = useAutomationsContext();
  const { automationJson, isObjectless } = dataByVariant;
  const slackStatus = useSelector(selectSlackIntegrationStatus);
  const { anyFormulaEditorOpenExists } = useFormulaEditorState();
  const { anyOtherObjectEditorOpenExists } = useValueFromAnotherObjectEditorState();

  return getIsAutomationsFormValid({
    automationJson,
    slackStatus,
    isObjectless,
    anyFormulaEditorOpenExists,
    anyOtherObjectEditorOpenExists,
  });
};
